export const rowStyles = {
  display: 'grid',
  gridTemplateColumns: '220px minmax(0, 1fr)',
  gap: '24px',
  padding: '16px',

  '&:not(:last-of-type)': {
    borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  },
};

export const summaryStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  minWidth: 0,
};

export const inputsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minWidth: 0,
};

export const reasonHelpStyles = {
  marginTop: '-8px',
};
